// Aviso de atualização: o processo principal baixa a versão nova em segundo
// plano; aqui só mostramos o estado e o botão para reiniciar.

import { el } from "./dom.js";
import * as recording from "./recording.js";

let state = { status: "off" };
const listeners = new Set();

export function describe(s = state) {
  return {
    off: window.ordo?.web ? "Na versão web você sempre usa a versão mais recente." : "A atualização automática funciona no app instalado no Windows.",
    idle: "Atualização automática ligada.",
    latest: "Você está na versão mais recente.",
    checking: "Procurando atualizações…",
    downloading: `Baixando a versão ${s.version || ""}… ${s.percent || 0}%`,
    ready: `A versão ${s.version} está pronta para instalar.`,
    error: "Não foi possível procurar atualizações agora. O Ordo tenta de novo mais tarde.",
  }[s.status] || "";
}

export function onChange(fn) {
  listeners.add(fn);
  fn(state);
  return () => listeners.delete(fn);
}

function set(s) {
  state = s || { status: "off" };
  for (const fn of listeners) fn(state);
}

export const check = async () => set(await window.ordo.checkUpdates());

export async function install() {
  if (recording.current) return false;
  return window.ordo.installUpdate();
}

export function mountUpdateBar() {
  const text = el("span", {});
  const btn = el("button", { class: "primary small", onclick: install }, "Reiniciar e atualizar");
  const bar = el("div", { class: "update-bar", hidden: true, role: "status" },
    el("span", { class: "update-dot" }), text, btn,
    el("button", { class: "icon-btn tiny", title: "Lembrar depois", onclick: () => { bar.hidden = true; } }, "✕"));
  document.body.append(bar);
  const draw = () => {
    bar.hidden = state.status !== "ready" || bar.dataset.dismissed === state.version;
    text.textContent = `Nova versão ${state.version || ""} pronta.`;
    btn.disabled = !!recording.current;
    btn.title = recording.current ? "Disponível quando a transcrição terminar" : "";
  };
  bar.lastChild.addEventListener("click", () => { bar.dataset.dismissed = state.version; });
  onChange(draw);
  recording.on("state", draw);
  window.ordo.onUpdate(set);
  window.ordo.updateState().then(set).catch(() => {});
}
